import React, { useEffect, useRef, useState } from 'react';
import './Career.scss';

import locationIcon from '../../assets/img/location.svg';
import locationTypeIcon from '../../assets/img/location__type.svg';
const Career = () => {

    return (
        <>
            <section className="upper-wrapper">
                <div className="container">
                    <h1 className="title title_main">
                        Наши вакансии
                    </h1>
                </div>
            </section>

            <section className="vacancy-block">
                <div className="container">
                    {/* Vacancy 1 */}
                    <div className="vacancy">
                        <div className="vacancy__name">
                            Front-end разработчик
                        </div>
                        <div className="vacancy__location">
                            <img src={locationIcon} alt="location" />
                            Весь мир
                        </div>
                        <div className="vacancy__type">
                            <img src={locationTypeIcon} alt="type" />
                            Можно удалённо
                        </div>
                        <div className="line"></div>
                    </div>

                    {/* Vacancy 2 */}
                    <div className="vacancy">
                        <div className="vacancy__name">
                            Back-end разработчик
                        </div>
                        <div className="vacancy__location">
                            <img src={locationIcon} alt="location" />
                            Весь мир
                        </div>
                        <div className="vacancy__type">
                            <img src={locationTypeIcon} alt="type" />
                            Можно удалённо
                        </div>
                        <div className="line"></div>
                    </div>

                    {/* Vacancy 3 */}
                    <div className="vacancy">
                        <div className="vacancy__name">
                            Проектный менеджер
                        </div>
                        <div className="vacancy__location">
                            <img src={locationIcon} alt="location" />
                            Шымкент
                        </div>
                        <div className="vacancy__type">
                            <img src={locationTypeIcon} alt="type" />
                            Частично удалённо
                        </div>
                        <div className="line"></div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Career;
